import styled from '@emotion/styled'
import { colors, radius, shadow } from '@mobi/component-library/Foundations'

export const IconWrapperStyled = styled.span({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: radius.md,
  boxShadow: shadow.sm,
  overflow: 'hidden',
  border: '0.2rem solid ' + colors.white,

  '> img': {
    width: '100%',
    height: 'auto',
  },
})
